import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-6 md:px-8 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-spy-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                黑料曝光
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚最新、最全的真实内幕信息。娱乐圈、商业圈、网红博主，第一时间呈现经过核实的黑料曝光内容，助你看清真相、辨别是非。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all" aria-label="RSS">
                <i className="ri-rss-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['偷税漏税', '刷单内幕', '直播带货', '食品安全', '潜规则', '数据隐私', '阴阳合同', '代打代练'].map((tag) => (
                <span key={tag} className="px-2.5 py-1 text-xs rounded-md bg-background-800 text-background-300 whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</Link>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">用户协议</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">投稿爆料</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-6 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto">
          <p className="text-xs text-background-500">© 2026 黑料曝光 HeiLiaoBaoGuang.com 版权所有 | 京ICP备XXXXXXXX号</p>
          <p className="text-xs text-background-500">本站内容仅供参考，不构成任何建议。如有不实信息，请联系我们删除。</p>
        </div>
      </div>
    </footer>
  );
}